import React, { Fragment } from 'react';
import { SvgIcon } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<Fragment>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark"/>
                </div>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark icon-2x"/>
                </div>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark icon-3x"/>
                </div>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark icon-4x"/>
                </div>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark icon-5x"/>
                </div>
                <div className="flex-row">
                    <SvgIcon kind="Smile" className="icon icon-dark icon-7x"/>
                </div>
            </Fragment>);
    }
}
